import { lazy, Suspense } from "react";
import { Navigate, type RouteObject } from "react-router";
import TodayPage from "@/pages/today";
import { AppShell } from "./layout/app-shell";
import { RequireAuth } from "./require-auth";

// Today is the home screen and ships in the main bundle. Every other page
// loads on demand (and is precached by the service worker for offline use),
// so heavy libraries like Recharts, TanStack Table and zod stay off first paint.
const InboxPage = lazy(() => import("@/pages/inbox"));
const PlanPage = lazy(() => import("@/pages/plan"));
const MoneyPage = lazy(() => import("@/pages/money"));
const HabitsPage = lazy(() => import("@/pages/habits"));
const FocusPage = lazy(() => import("@/pages/focus"));
const StudyPage = lazy(() => import("@/pages/study"));
const ReviewsPage = lazy(() => import("@/pages/reviews"));
const InsightsPage = lazy(() => import("@/pages/insights"));
const SettingsPage = lazy(() => import("@/pages/settings"));
const LoginPage = lazy(() => import("@/pages/login"));
const NotFoundPage = lazy(() => import("@/pages/not-found"));

export const routes: RouteObject[] = [
	{
		path: "/login",
		element: (
			<Suspense fallback={null}>
				<LoginPage />
			</Suspense>
		),
	},
	{
		element: (
			<RequireAuth>
				<AppShell />
			</RequireAuth>
		),
		children: [
			{ index: true, element: <Navigate to="/today" replace /> },
			{ path: "today", element: <TodayPage /> },
			{ path: "inbox", element: <InboxPage /> },
			{ path: "plan", element: <PlanPage /> },
			{ path: "money", element: <MoneyPage /> },
			{ path: "habits", element: <HabitsPage /> },
			{ path: "focus", element: <FocusPage /> },
			{ path: "study", element: <StudyPage /> },
			{ path: "reviews", element: <ReviewsPage /> },
			{ path: "insights", element: <InsightsPage /> },
			{ path: "settings", element: <SettingsPage /> },
			{ path: "*", element: <NotFoundPage /> },
		],
	},
];
